/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M4 1L1 4M20 1L23 4M8 12H16"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<circle
				cx="12"
				cy="12"
				r="10"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<rect
				opacity="0.12"
				x="2"
				y="2"
				width="20"
				height="20"
				rx="10"
				fill="currentColor"
			/>
			<path
				d="M4 1L1 4M20 1L23 4M8 12H16M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M4.53033 1.53033C4.82322 1.23744 4.82322 0.762563 4.53033 0.46967C4.23744 0.176777 3.76256 0.176777 3.46967 0.46967L0.46967 3.46967C0.176777 3.76256 0.176777 4.23744 0.46967 4.53033C0.762563 4.82322 1.23744 4.82322 1.53033 4.53033L4.53033 1.53033ZM20.5303 0.46967C20.2374 0.176777 19.7626 0.176777 19.4697 0.46967C19.1768 0.762563 19.1768 1.23744 19.4697 1.53033L22.4697 4.53033C22.7626 4.82322 23.2374 4.82322 23.5303 4.53033C23.8232 4.23744 23.8232 3.76256 23.5303 3.46967L20.5303 0.46967ZM12 1.25C6.06294 1.25 1.25 6.06294 1.25 12C1.25 17.9371 6.06294 22.75 12 22.75C17.9371 22.75 22.75 17.9371 22.75 12C22.75 6.06294 17.9371 1.25 12 1.25ZM7.25 12C7.25 11.5858 7.58579 11.25 8 11.25H12H16C16.4142 11.25 16.75 11.5858 16.75 12C16.75 12.4142 16.4142 12.75 16 12.75H12H8C7.58579 12.75 7.25 12.4142 7.25 12Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M2.20004 14C2.06886 13.3538 2 12.6849 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C9.20261 22 6.67349 20.8514 4.85857 19M4 1L1 4M20 1L23 4M7.99997 12H16"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M4 1L1 4M20 1L23 4M8 12H16M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M12 1.25C6.06294 1.25 1.25 6.06294 1.25 12C1.25 17.9371 6.06294 22.75 12 22.75C17.9371 22.75 22.75 17.9371 22.75 12C22.75 6.06294 17.9371 1.25 12 1.25Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M4.53033 1.53033C4.82322 1.23744 4.82322 0.762563 4.53033 0.46967C4.23744 0.176777 3.76256 0.176777 3.46967 0.46967L0.46967 3.46967C0.176777 3.76256 0.176777 4.23744 0.46967 4.53033C0.762563 4.82322 1.23744 4.82322 1.53033 4.53033L4.53033 1.53033ZM20.5303 0.46967C20.2374 0.176777 19.7626 0.176777 19.4697 0.46967C19.1768 0.762563 19.1768 1.23744 19.4697 1.53033L22.4697 4.53033C22.7626 4.82322 23.2374 4.82322 23.5303 4.53033C23.8232 4.23744 23.8232 3.76256 23.5303 3.46967L20.5303 0.46967ZM8 11.25C7.58579 11.25 7.25 11.5858 7.25 12C7.25 12.4142 7.58579 12.75 8 12.75H12H16C16.4142 12.75 16.75 12.4142 16.75 12C16.75 11.5858 16.4142 11.25 16 11.25H12H8Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
